export default __webpack_public_path__ + "static/media/three-arrow-capital.794a83f5.svg";